/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Sequence from './sequence';
import SequenceDetail from './sequence-detail';
import SequenceUpdate from './sequence-update';
import SequenceDeleteDialog from './sequence-delete-dialog';

const SequenceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Sequence />} />
    <Route path="new" element={<SequenceUpdate />} />
    <Route path=":id">
      <Route index element={<SequenceDetail />} />
      <Route path="edit" element={<SequenceUpdate />} />
      <Route path="delete" element={<SequenceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SequenceRoutes;
